import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faPhone } from '@fortawesome/pro-light-svg-icons/faPhone';
import { Agent } from '@propertypal/shared/src/types/property';
import router from 'next/router';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import Button from '../buttons/Button';
import { ButtonRow, Container } from './FeaturedSearchAgent.style';

interface Props {
  agent?: Agent;
  onCallClick: (agent: Agent) => void;
}

const FeaturedSearchAgent: FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  if (!props.agent) {
    return null;
  }

  return (
    <Container>
      <h3>Featured Agent</h3>

      <img src={props.agent.logo?.standard} alt={props.agent.organisation} />

      <p>{props.agent.displayAddress}</p>

      <ButtonRow>
        <Button
          icon={faEnvelope}
          color={theme.background}
          fontColor={theme.textDark}
          iconColour={theme.textDark}
          containerStyle={{ border: `1px solid ${theme.textDark}` }}
          // @ts-ignore
          onClick={() => router.push(props.agent?.landingPageUrl.url)}
        >
          Email
        </Button>
        <Button
          icon={faPhone}
          color={theme.background}
          fontColor={theme.textDark}
          iconColour={theme.textDark}
          containerStyle={{ border: `1px solid ${theme.textDark}` }}
          onClick={() => props.agent && props.onCallClick(props.agent)}
        >
          Phone
        </Button>
      </ButtonRow>
    </Container>
  );
};

export default FeaturedSearchAgent;
